import { useMsal } from '@azure/msal-react'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Box, Button, Card, CardContent, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

const BootstrapErrorPage = () => {
  const theme = useTheme()
  const { instance } = useMsal()
  const { t } = useTranslation()

  const handleLogout = () => {
    instance.logoutRedirect()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: theme.palette.background.default,
        padding: 3,
      }}
    >
      <Card
        elevation={6}
        sx={{
          maxWidth: 500,
          width: '100%',
          borderTop: `6px solid ${theme.palette.primary.main}`,
        }}
      >
        <CardContent sx={{ padding: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <ErrorOutlineIcon sx={{ fontSize: 40, color: theme.palette.primary.main, mr: 2 }} />
            <Typography variant="h5" component="h1" sx={{ color: theme.palette.secondary.main, fontWeight: 600 }}>
              {t('bootstrapError.title')}
            </Typography>
          </Box>

          <Typography variant="body1" sx={{ color: theme.palette.secondary.main, mb: 2, lineHeight: 1.7 }}>
            {t('bootstrapError.description')}
          </Typography>

          <Typography variant="body2" sx={{ color: theme.palette.primary.main, mb: 2, lineHeight: 1.7,  fontWeight: 600}}>
            {t('bootstrapError.firstLogin')}
          </Typography>

          <Typography variant="body2" sx={{ color: theme.palette.secondary.main, mb: 3, lineHeight: 1.7 }}>
            {t('bootstrapError.contact')}{' '}
            <Box
              component="a"
              href="mailto:support@pmpsolutions.ca"
              sx={{ color: theme.palette.primary.main, textDecoration: 'underline' }}
            >
              support@pmpsolutions.ca
            </Box>
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button variant="outlined" color="primary" onClick={() => window.location.reload()} sx={{ px: 4, py: 1.5 }}>
              {t('bootstrapError.retry')}
            </Button>
            <Button variant="contained" color="primary" onClick={handleLogout} sx={{ px: 4, py: 1.5 }}>
              {t('bootstrapError.backToLogin')}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default BootstrapErrorPage
